import Service from "../Service";
import AuthService from "../AuthService";

const Auth = {
  login(data) {
    return Service.post("/login", data);
  },

  getUser() {
    return AuthService.get("/user");
  },

  logout() {
    return AuthService.get("/logout");
  },

  confirmPassword(payload) {
    return AuthService.post("/confirm-password", payload);
  },
  checkAllPermission() {
    return AuthService.get("/check-permission/all");
  },
};

export default Auth;
